import { render } from "./DJvirtualCommerce.vue?vue&type=template&id=d8d9fa8e&scoped=true"
import script from "./DJvirtualCommerce.vue?vue&type=script&lang=js"
export * from "./DJvirtualCommerce.vue?vue&type=script&lang=js"

import "./DJvirtualCommerce.vue?vue&type=style&index=0&id=d8d9fa8e&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-d8d9fa8e"

export default script